import React from 'react'
import { MP } from '@newageerp/crm-ui'
import { useParams } from '@newageerp/v3.templates.templates-core'
import { useDataCache } from '@newageerp/v3.app.data-cache-provider';

export default function MpEndPoint() {
    const params = useParams();
    const { system: dsSystem } = useDataCache();
    return (
        <MP.GlobalProvider settings={{
            apiKey: dsSystem.data.settings.mp.apiKey,
            baseUrl: dsSystem.data.settings.mp.baseUrl,
        }}>
            <MP.InfoProvider key={`dt-${params.dataSource}`} dataSource={params.dataSource} contentChildren={<MP.Data />} user='all' />
        </MP.GlobalProvider>
    )
}
